import axios from "axios";

export const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
});

export const authHeader = () => ({
  Authorization: `Bearer ${localStorage.getItem("quizzy_admin_token") || ""}`,
});
